import React from "react";

const RecorderStopIcon = props => {
  return (
    <svg
      width="32"
      {...props}
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" fill="white" />
      <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#64748B" />
      <path
        d="M12.6673 11.3359H19.334C19.6876 11.3359 20.0267 11.4764 20.2768 11.7265C20.5268 11.9765 20.6673 12.3156 20.6673 12.6693V19.3359C20.6673 19.6896 20.5268 20.0287 20.2768 20.2787C20.0267 20.5288 19.6876 20.6693 19.334 20.6693H12.6673C12.3137 20.6693 11.9746 20.5288 11.7245 20.2787C11.4745 20.0287 11.334 19.6896 11.334 19.3359V12.6693C11.334 12.3156 11.4745 11.9765 11.7245 11.7265C11.9746 11.4764 12.3137 11.3359 12.6673 11.3359Z"
        fill="#EF4444"
      />
    </svg>
  );
};

export default RecorderStopIcon;
